<template>
  <div class="filters">
    <div class="filters--toggle text-right mb-2 d-md-none">
      <b-button
        class="d-inline-flex align-items-center"
        variant="outline-cta"
        size="sm"
        @click="toggle_filters"
      >
        <div v-html="filters"></div>
        <span>Filtra</span>
      </b-button>
    </div>
    <section
      class="filters--wrapper d-md-block"
      :style="filters_open ? 'transform: translate(0)' : ''"
    >
      <header class="filters--wrapper--header d-md-none">
        <b-container fluid>
          <div
            class="filters--wrapper--header-top py-2 d-flex align-items-center justify-content-between"
          >
            <span>Filtra</span>
            <b-button variant="light" size="sm" @click="toggle_filters">Fatto</b-button>
          </div>
          <div class="filters--tags">
            <b-button
              block
              :disabled="!has_filters"
              variant="cta"
              size="sm"
              @click="remove_all_filters"
              >Cancella filtri</b-button
            >
          </div>
        </b-container>
      </header>

      <section class="filters--wrapper--block">
        <div class="filters--block">
          <div class="filters--title">Ordina per</div>
          <div class="filters--content">
            <div
              v-for="(sorting, value) in sorting_options"
              :key="value"
              class="filters--orderby--item"
            >
              <div
                :class="
                  is_current_sorting(value)
                    ? 'filters--orderby--active'
                    : 'filters--orderby--default'
                "
                @click="set_sorting(value)"
              >
                {{ sorting.title }}
              </div>
            </div>
          </div>
        </div>

        <div class="filters--block filters--block--search-by">
          <div class="filters--title">Cerca</div>
          <div class="filters--content">
            <search-by-connections class="is-search" />
            <search-by-bags class="is-search" />
            <search-by-cabin class="is-search" />
          </div>
        </div>

        <div class="filters--block">
          <div class="filters--title">Filtra per</div>

          <div class="filters--content">
            <!--<b-form-group>
              <b-form-checkbox v-model="filter_included_bags">
                Bagagli inclusi <span class="icon" v-html="info" fill-tertiary v-b-popover.hover.top="'Verifica le franchigie sul sito della compagnia'"></span>
              </b-form-checkbox>
            </b-form-group>-->

            <!--<b-form-group>
              <b-form-checkbox v-model="filter_extra_bags">
                Bagagli EXTRA disponibili <span class="icon" v-html="info" fill-tertiary v-b-popover.hover.top="'Con supplemento pagabile al check-out della prenotazione'"></span>
              </b-form-checkbox>
            </b-form-group>-->
          </div>

          <div class="filters--content" v-if="Object.keys(carriers).length != 0">
            <div class="filters--subtitle">Compagnie aeree</div>
            <b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-carriers"
                v-model="filter_carriers"
                name="checkbox-group-carriers"
              >
                <b-form-checkbox
                  v-for="(carrier, carrier_index) in carriers"
                  v-bind:key="_uid + carrier_index"
                  :value="carrier.value"
                >
                  {{ carrier.text }} ({{ carrier.amount }})
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>

        <div class="filters--block">
          <div class="filters--content">
            <div class="filters--subtitle">Orario andata</div>
            <div class="filters--square-buttons">
              <div
                class="filters--square-button"
                :class="filter_round_trip_departure == 'morning' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_round_trip_departure !== 'morning') {
                      filter_round_trip_departure = 'morning';
                    } else {
                      filter_round_trip_departure = '';
                    }
                  }
                "
              >
                <div class="icon" v-html="sun"></div>
                <div>Mattina</div>
                <div>(6:00 - 12:00)</div>
              </div>
              <div
                class="filters--square-button"
                :class="filter_round_trip_departure == 'early_afternoon' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_round_trip_departure == 'early_afternoon') {
                      filter_round_trip_departure = '';
                    } else {
                      filter_round_trip_departure = 'early_afternoon';
                    }
                  }
                "
              >
                <div class="icon" v-html="sun_half"></div>
                <div>Primo pomeriggio</div>
                <div>(12:00 - 15:00)</div>
              </div>
              <div
                class="filters--square-button"
                :class="filter_round_trip_departure == 'late_afternoon' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_round_trip_departure == 'late_afternoon') {
                      filter_round_trip_departure = '';
                    } else {
                      filter_round_trip_departure = 'late_afternoon';
                    }
                  }
                "
              >
                <div class="icon" v-html="sun_half"></div>
                <div>Tardo pomeriggio</div>
                <div>(15:00 - 18:00)</div>
              </div>
              <div
                class="filters--square-button"
                :class="filter_round_trip_departure == 'evening' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_round_trip_departure == 'evening') {
                      filter_round_trip_departure = '';
                    } else {
                      filter_round_trip_departure = 'evening';
                    }
                  }
                "
              >
                <div class="icon" v-html="moon"></div>
                <div>Sera</div>
                <div>(18:00 - 6:00)</div>
              </div>
            </div>
          </div>
        </div>

        <!-- disattivato https://trello.com/c/BSOxHzdA/1818-rifiniture-filtri-ricerca
              <div class="filters--block">
                <div class="filters--content">
                  <div class="filters--subtitle">
                    Orario Arrivo
                  </div>
                  <div class="filters--square-buttons">
                    <div class="filters--square-button" :class="filter_round_trip_arrival == 'morning' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival !== 'morning') {
                        filter_round_trip_arrival = 'morning'
                      } else {
                        filter_round_trip_arrival = ''
                      }
                    }">
                      <div class="icon" v-html="sun"></div>
                      <div>Mattina</div>
                      <div>(6:00 - 12:00)</div>
                    </div>
                    <div class="filters--square-button" :class="filter_round_trip_arrival == 'early_afternoon' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival == 'early_afternoon') {
                        filter_round_trip_arrival = ''
                      } else {
                        filter_round_trip_arrival = 'early_afternoon'
                      }
                    }">
                      <div class="icon" v-html="sun_half"></div>
                      <div>Primo pomeriggio</div>
                      <div>(12:00 - 15:00)</div>
                    </div>
                    <div class="filters--square-button" :class="filter_round_trip_arrival == 'late_afternoon' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival == 'late_afternoon') {
                        filter_round_trip_arrival = ''
                      } else {
                        filter_round_trip_arrival = 'late_afternoon'
                      }
                    }">
                      <div class="icon" v-html="sun_half"></div>
                      <div>Tardo pomeriggio</div>
                      <div>(15:00 - 18:00)</div>
                    </div>
                    <div class="filters--square-button" :class="filter_round_trip_arrival == 'evening' ? 'active' : ''" @click="() => {
                      if(filter_round_trip_arrival == 'evening') {
                        filter_round_trip_arrival = ''
                      } else {
                        filter_round_trip_arrival = 'evening'
                      }
                    }">
                      <div class="icon" v-html="moon"></div>
                      <div>Sera</div>
                      <div>(18:00 - 6:00)</div>
                    </div>
                  </div>
                </div>
              </div> -->

        <div class="filters--block" v-if="return_flight">
          <div class="filters--content">
            <div class="filters--subtitle">Orario ritorno</div>
            <div class="filters--square-buttons">
              <div
                class="filters--square-button"
                :class="filter_return_trip_departure == 'morning' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_return_trip_departure !== 'morning') {
                      filter_return_trip_departure = 'morning';
                    } else {
                      filter_return_trip_departure = '';
                    }
                  }
                "
              >
                <div class="icon" v-html="sun"></div>
                <div>Mattina</div>
                <div>(6:00 - 12:00)</div>
              </div>
              <div
                class="filters--square-button"
                :class="filter_return_trip_departure == 'early_afternoon' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_return_trip_departure == 'early_afternoon') {
                      filter_return_trip_departure = '';
                    } else {
                      filter_return_trip_departure = 'early_afternoon';
                    }
                  }
                "
              >
                <div class="icon" v-html="sun_half"></div>
                <div>Primo pomeriggio</div>
                <div>(12:00 - 15:00)</div>
              </div>
              <div
                class="filters--square-button"
                :class="filter_return_trip_departure == 'late_afternoon' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_return_trip_departure == 'late_afternoon') {
                      filter_return_trip_departure = '';
                    } else {
                      filter_return_trip_departure = 'late_afternoon';
                    }
                  }
                "
              >
                <div class="icon" v-html="sun_half"></div>
                <div>Tardo pomeriggio</div>
                <div>(15:00 - 18:00)</div>
              </div>
              <div
                class="filters--square-button"
                :class="filter_return_trip_departure == 'evening' ? 'active' : ''"
                @click="
                  () => {
                    if (filter_return_trip_departure == 'evening') {
                      filter_return_trip_departure = '';
                    } else {
                      filter_return_trip_departure = 'evening';
                    }
                  }
                "
              >
                <div class="icon" v-html="moon"></div>
                <div>Sera</div>
                <div>(18:00 - 6:00)</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <span v-if="filters_open" class="filters--overlay" @click="toggle_filters"></span>
  </div>
</template>
<script>
import { chevron_down } from '@/components/svg/chevrons';
import { clock, info, filters } from '@/components/svg/common';
import { sun, sun_half, moon } from '@/components/svg/flight';
import SearchByConnections from '@/components/blocks/search-by-connections';
import SearchByBags from '@/components/blocks/search-by-bags';
import SearchByCabin from '@/components/blocks/search-by-cabin';
import { sorting_options, is_current_sorting, set_sorting } from '@/utilities/sorting';

export default {
  name: 'filters',
  props: {
    filtered_all_carriers: {
      type: Array,
    },
  },
  components: {
    'search-by-connections': SearchByConnections,
    'search-by-bags': SearchByBags,
    'search-by-cabin': SearchByCabin,
  },
  created() {
    this.chevron_down = chevron_down;
    this.clock = clock;
    this.sun = sun;
    this.sun_half = sun_half;
    this.moon = moon;
    this.info = info;
    this.filters = filters;
  },
  data() {
    return {
      // data e non computed perchè NON deve essere reattiva a modifiche nel booking engine
      // in caso contrario il filtro potrebbe sparire/apparire quando cambio A - A/R nel booking engine in modo incoerente ai risultati che sto mostrando
      return_flight: this.$store.state.liveflight.return_flight,
      filters_open: false,
      sorting_options,
    };
  },
  computed: {
    carriers: {
      get() {
        return this.calculate_carriers();
      },
      set() {},
    },
    filter_carriers: {
      get() {
        return this.$store.state.liveflight.filter_carriers;
      },
      set(value) {
        this.$store.commit('filter_carriers', value);
      },
    },
    filter_round_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_departure;
      },
      set(value) {
        this.$store.commit('filter_round_trip_departure', value);
        this.calculate_carriers();
      },
    },
    filter_round_trip_arrival: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_arrival;
      },
      set(value) {
        this.$store.commit('filter_round_trip_arrival', value);
        this.calculate_carriers();
      },
    },
    filter_return_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_return_trip_departure;
      },
      set(value) {
        this.$store.commit('filter_return_trip_departure', value);
        this.calculate_carriers();
      },
    },
    filter_included_bags: {
      get() {
        return this.$store.state.liveflight.filter_included_bags;
      },
      set(value) {
        this.$store.commit('filter_included_bags', value);
        this.calculate_carriers();
      },
    },
    filter_extra_bags: {
      get() {
        return this.$store.state.liveflight.filter_extra_bags;
      },
      set(value) {
        this.$store.commit('filter_extra_bags', value);
        this.calculate_carriers();
      },
    },
    has_filters: {
      get() {
        return (
          this.filter_carriers.length |
          (this.filter_round_trip_departure != '') |
          (this.filter_round_trip_arrival != '') |
          (this.filter_return_trip_departure != '') |
          this.filter_included_bags |
          this.filter_extra_bags
        );
      },
    },
  },
  mounted() {},
  methods: {
    set_sorting,
    is_current_sorting,
    calculate_carriers() {
      if (Object.keys(this.$store.state.liveflight.results).length == 0) return [];

      let options = [],
        carriers = this.$store.state.liveflight.results.dictionaries.carriers,
        flights = this.filtered_all_carriers; //this.$store.state.liveflight.results.flights

      if (!carriers) return [];

      for (const [key, value] of Object.entries(carriers)) {
        let amount = flights.filter(function (f) {
          return f.itineraries[0].segments[0].carrierCode == key;
        }).length;

        if (amount == 0) continue;

        options.push({
          text: value,
          value: key,
          amount: amount,
        });
      }

      options.sort((a, b) => {
        /*if (a.amount < b.amount) return 1;
          if (a.amount > b.amount) return -1;*/
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });

      return options;
    },

    toggle_filters() {
      this.filters_open = !this.filters_open;
      if (this.filters_open) return document.body.classList.add('overflow-hidden');
      return document.body.classList.remove('overflow-hidden');
    },

    remove_all_filters() {
      this.filter_carriers = [];
      this.filter_round_trip_departure = '';
      this.filter_round_trip_arrival = '';
      this.filter_return_trip_departure = '';
      this.filter_included_bags = false;
      this.filter_extra_bags = false;
    },
  },
};
</script>

<style lang="scss">
.filters {
  &--toggle {
    margin-right: 8px;

    svg {
      width: 16px;
      height: 16px;
      fill: #0a76bd;
      margin-right: 5px;
    }

    button {
      span {
        font-size: 13px;
      }
    }
  }

  &--wrapper {
    position: fixed;
    top: 0;
    right: 0;
    width: 90%;
    max-width: 25rem;
    z-index: 3;
    background: #fff;
    height: 100%;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
    transform: translate(100%);
    transition: transform 0.2s ease;

    @include media-breakpoint-up(md) {
      position: static;
      width: auto;
      max-width: none;
      z-index: auto;
      box-shadow: none;
      transform: translate(0);
    }

    &--header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      font-size: 17px;
      background-color: $white;
      z-index: 2;

      span {
        color: #000;
        font-weight: 600;
      }
      button {
        font-weight: 500;
        font-size: 17px;
      }
    }

    &--block {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 110px 15px 0;

      @include media-breakpoint-up(md) {
        padding: 0;
      }
    }
  }

  &--block {
    margin-bottom: $grid-gutter-width/2;
    border-bottom: 1px solid $light-gray;

    &:last-child {
      border-bottom: none;
    }
  }

  // &--content {
  //   margin-bottom: $grid-gutter-width;
  // }

  &--title {
    @include font-primary-regular;
    color: $text;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: $grid-gutter-width/3;
  }

  &--subtitle {
    font-size: 16px;
    @include font-primary-regular;
    display: block;
    margin-bottom: $grid-gutter-width/2;

    @include media-breakpoint-up(md) {
      font-size: 14px;
    }
  }

  &--orderby {
    &--item {
      display: block;
      cursor: pointer;
      margin-bottom: 10px;
    }
    &--default,
    &--active {
      transition: $transition-base;
      padding: $btn-padding-y-sm $btn-padding-x-sm;
      border-radius: $border-radius-sm;
    }
    &--active {
      color: $cta;
      font-weight: 700;
    }
  }

  &--square-buttons {
    display: flex;
    flex-wrap: wrap;
  }

  &--square-button {
    width: calc(50% - #{$grid-gutter-width/4});
    @include font-primary-regular;
    font-size: 12px;
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid $tertiary;
    color: $tertiary;
    border-radius: $border-radius-sm;
    text-align: center;
    line-height: 120%;

    svg {
      height: 19px;
    }

    & > div:nth-child(1) {
    }
    & > div:nth-child(2) {
      padding: 6px 0 3px 0;
      font-size: 12px;
    }
    & > div:nth-child(3) {
      font-size: 10px;
    }
    &:nth-child(even) {
      margin-left: $grid-gutter-width/8;
    }
    &:nth-child(odd) {
      margin-right: $grid-gutter-width/8;
    }
    margin-bottom: $grid-gutter-width/2;
    transition: $transition-base;
    cursor: pointer;
    &.active
      //&:hover
    {
      border-color: $light-blue;
      background-color: $light-blue;
    }
  }

  &--overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    z-index: 1;
    opacity: 0.25;
  }

  .custom-checkbox {
    margin-bottom: $grid-gutter-width/2;

    @include media-breakpoint-up(md) {
      margin-bottom: $grid-gutter-width/4;
    }
  }

  .filters--block--search-by {
    .is-search {
      margin-bottom: 1rem;
    }
    .custom-checkbox {
      margin-bottom: 0;
    }
    select {
      padding: 0;
    }
  }

  &--block:not(.filters--block--search-by) .custom-checkbox {
    width: 100%;
    label:before,
    label:after {
      border-color: $tertiary;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .dropdown {
    width: 100%;
    .btn > .d-flex {
      min-width: 100%;
    }
  }
}
</style>
